import { NgModule } from '@angular/core';
import { Routes, RouterModule, Route, TitleStrategy as AngularTitleStrategy } from '@angular/router';
import { TitleStrategy } from './routing/strategies/title.strategy';
import { authGuard } from './routing/guards/auth.guard';
import { ROUTE_METADATA } from './core/navigation/services/navigation.service';

const emptyPathRoute: Route = {
	title: 'DEFAULT',
	path: '',
	redirectTo: 'home',
	pathMatch: 'full',
	data: ROUTE_METADATA.Empty
};

//Allow URL without login
export const urlWithoutLogin: string[] = ["forgot-password","redirect-access","login","drupal-authentication"];

// Define other static routes in this array (excluding the wildcard route).
const staticRoutes: Routes = [
	{
		title: 'Login',
		path: 'login',
		canActivate: [authGuard],
		loadComponent: () => import('src/app/pages/login/login.component'),
		data: ROUTE_METADATA.Login
	},
	{
		title: 'Forgot Password',
		path: 'forgot-password',
		loadComponent: () => import('src/app/pages/forgot/forgotpassword/forgotpassword.component')
		//,data: ROUTE_METADATA.ForgotPassword
	},
	{
		title: 'Redirect Authentication',
		path: 'redirect-access',
		canActivate: [authGuard],
		loadComponent: () => import('src/app/pages/login/redirect-access/redirect-access.component'),
		data: ROUTE_METADATA.RedirectAccess
	},
	{
		title: 'Drupal Authentication',
		path: 'drupal-authentication',
		loadComponent: () => import('src/app/pages/dealer-portal-auth/dealer-portal-auth.component'),
		data: ROUTE_METADATA.DealerPortalAuth
	},
	// ,
	// {
	// 	title: 'Help',
	// 	path: 'help',
	// 	canActivate: [authGuard],
	// 	loadChildren: () => import('src/app/pages/help/help.module').then((importParam) => importParam.HelpNewModule),
	// 	data: ROUTE_METADATA.Help
	// },
];

const wildcardRoute: Route = {
	title: 'Not Found',
	path: '**',
	canActivate: [authGuard],
	loadComponent: () => import('src/app/pages/not-found/not-found.component'),
	data: ROUTE_METADATA.NotFound
};

@NgModule({
	imports: [
		RouterModule.forRoot(
			[emptyPathRoute, ...staticRoutes, wildcardRoute],
			{
				onSameUrlNavigation: 'reload',
			}
		),
	],
	exports: [RouterModule],
	providers: [
		{
			provide: AngularTitleStrategy,
			useClass: TitleStrategy
		}
	]
})
export class AppRoutingModule {
	// Expose the routes for use in RouteConfigService.
	static readonly emptyPathRoute = emptyPathRoute;
	static readonly staticRoutes = staticRoutes;
	static readonly wildcardRoute = wildcardRoute;
}
